<template>
  <div class="apply-hy-page">
    <div  class="top-page-all">
      <div @click="onClickLeft" class="ret-btn"><</div>
      <div>我的客户列表</div>
    </div>
    <div class="top-bg-st"></div>
    <div class="content-box">
      <van-field
        @click="typeShow=true"
        v-model="typeLabel"
        label="类型"
        readonly="readonly"
        placeholder="请选择类型"
      />
      <van-popup :style="{width:'100%'}" position="bottom" v-model="typeShow">
        <van-picker :columns="selectList" @change="onChange"/>
      </van-popup>

      <van-field
        v-model="reason"
        rows="3"
        autosize
        label="申请理由"
        type="textarea"
        placeholder="请输入"
      />
      <div class="submit" @click="addData">提交</div>

    </div>

  </div>
</template>


<script>

  export default {
    name: "applyHy",
    data() {
      return {
        mid:'',
        typeShow:false,
        typeLabel:'周卡',
        type:1,
        selectList:['周卡','月卡','季度卡','年卡'],
        reason:'',
        postKey:true,
      };
    },
    mounted() {
      this.mid = this.$route.query.mid;
    },
    methods:{
      onClickLeft() {
        this.$router.go(-1);
      },
      onChange(picker, value, index) {
        console.log(picker,value,index)
        this.typeLabel = value;
        this.type = index + 1;

      },
      addData(){
        if(!this.postKey)return;
        if (!this.reason) {
          this.$toast("请输入申请理由");
          return;
        }
        this.postKey = false;
        let obj = {};
        obj.token = window.localStorage.getItem("token");
        obj.mid = this.mid;
        obj.type = this.type;
        obj.reason = this.reason;
        this.$http.post('memberyq', obj).then(
          res => {
            this.postKey = true;
            this.$toast(res.data.msg);
            if (res && res.data && res.data.code === 200) {
                setTimeout(() => {
                  this.$router.go(-1);
                }, 1500);
            }
          },
          e => {
            this.postKey = true;
            this.$toast("网络错误");
          }
        );

      }
    }

  };
</script>

<style lang="scss">
  #app {
    background: #eeeeee;
  }
  .apply-hy-page {
    .top-bg-st {
      position: relative;
      height: 2.4rem;
      width: 7.5rem;
      background-image: linear-gradient( to right,#038ED1, #1D208A);
    }
    .content-box {
      position: fixed;
      background: #ffffff;
      top: 1.24rem;
      width: 6.86rem;
      padding-bottom: 1.6rem;
      box-sizing: border-box;
      left: 0;
      right: 0;
      margin: 0 auto;
      border-radius: .32rem;
      padding-top: .32rem;
      color: #999999;
    }

    .submit {
      margin: .42rem auto 0;
      width: 4rem;
      height: .72rem;
      background-image: linear-gradient( to right,#038ED1, #1D208A);
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/applyHy.vue